module.exports = __webpack_public_path__ + "static/media/elo.03675758.svg";